export default __webpack_public_path__ + "static/media/scenario-b-home-insights.9c0dff0d.png";